var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareWithPhtoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 36,
    height: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8028 11.5H8C7.72386 11.5 7.5 11.7239 7.5 12V27.5C7.5 27.7761 7.72386 28 8 28H28C28.2761 28 28.5 27.7761 28.5 27.5V12C28.5 11.7239 28.2761 11.5 28 11.5H23.1972L21.3457 8.72265C21.2529 8.58355 21.0968 8.5 20.9296 8.5H15.0704C14.9032 8.5 14.7471 8.58355 14.6543 8.72265L12.8028 11.5ZM12 10H8C6.89543 10 6 10.8954 6 12V27.5C6 28.6046 6.89543 29.5 8 29.5H28C29.1046 29.5 30 28.6046 30 27.5V12C30 10.8954 29.1046 10 28 10H24L22.5937 7.8906C22.2228 7.3342 21.5983 7 20.9296 7H15.0704C14.4017 7 13.7772 7.3342 13.4063 7.8906L12 10Z",
    fill: "#1A7EE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 24.5C20.4853 24.5 22.5 22.4853 22.5 20C22.5 17.5147 20.4853 15.5 18 15.5C15.5147 15.5 13.5 17.5147 13.5 20C13.5 22.4853 15.5147 24.5 18 24.5ZM18 26C21.3137 26 24 23.3137 24 20C24 16.6863 21.3137 14 18 14C14.6863 14 12 16.6863 12 20C12 23.3137 14.6863 26 18 26Z",
    fill: "#1A7EE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 14C27 14.5523 26.5523 15 26 15C25.4477 15 25 14.5523 25 14C25 13.4477 25.4477 13 26 13C26.5523 13 27 13.4477 27 14Z",
    fill: "#1A7EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareWithPhtoCamera);
export default __webpack_public_path__ + "static/media/squareWithPhtoCamera.1d378742.svg";
export { ForwardRef as ReactComponent };